var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CareAppListActionFactory } from './action-factory';
var MemoCategoryActions = /** @class */ (function (_super) {
    __extends(MemoCategoryActions, _super);
    function MemoCategoryActions() {
        var _this = _super.call(this, 'MemoCategories') || this;
        _this.REQUEST_REMOVE_BY_ID = "[" + _this.type + "][Request] Remove By Id";
        _this.RESPONSE_SUCCESS_REMOVE_BY_ID = "[" + _this.type + "][Response][Success] Remove By Id";
        _this.RESPONSE_FAIL_REMOVE_BY_ID = "[" + _this.type + "][Response][Fail] Remove By Id";
        _this.REQUEST_ADD_BY_ID = "[" + _this.type + "][Request] Add By Id";
        _this.RESPONSE_SUCCESS_ADD_BY_ID = "[" + _this.type + "][Response][Success] Add By Id";
        _this.RESPONSE_FAIL_ADD_BY_ID = "[" + _this.type + "][Response][Fail] Add By Id";
        return _this;
    }
    MemoCategoryActions.prototype.ResponseSuccessByIdAction = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_BY_ID,
            payload: payload
        };
    };
    MemoCategoryActions.prototype.RequestRemoveById = function (payload) {
        return {
            type: this.REQUEST_REMOVE_BY_ID,
            payload: payload
        };
    };
    MemoCategoryActions.prototype.ResponseSuccessRemoveById = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_REMOVE_BY_ID,
            payload: payload
        };
    };
    MemoCategoryActions.prototype.ResponseFailRemoveById = function (payload) {
        return {
            type: this.RESPONSE_FAIL_REMOVE_BY_ID,
            payload: payload
        };
    };
    MemoCategoryActions.prototype.RequestAddById = function (payload) {
        return {
            type: this.REQUEST_ADD_BY_ID,
            payload: payload
        };
    };
    MemoCategoryActions.prototype.ResponseSuccessAddById = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_ADD_BY_ID,
            payload: payload
        };
    };
    MemoCategoryActions.prototype.ResponseFailAddById = function (payload) {
        return {
            type: this.RESPONSE_FAIL_ADD_BY_ID,
            payload: payload
        };
    };
    return MemoCategoryActions;
}(CareAppListActionFactory));
export var MemoCategories = new MemoCategoryActions();
